<template>
    <footer class="container text-center" style="margin-bottom:20px;">
        <ul class="list-inline">
            <!-- foreach lingue -->
            <li class="list-inline-item"
                v-for="lingua in this.lingueAttive"
                :key="lingua.codice">
                <a @click="locale = lingua.codice" class="btn btn-lang"
                   :class="{ active: lingua.codice.toUpperCase() === locale.toUpperCase()}">
                    {{lingua.codice.toUpperCase()}}
                </a>
            </li>
        </ul>
    </footer>
</template>

<script>
    export default {
        props: ['lingueAttive'],
        computed: {
            locale: {
                get: function () {
                    return this.$store.state.localization.language;
                },
                set: function (language) {
                    this.$store.dispatch('localization/setLanguage', language)
                }
            }
        }
    }
</script>
